import React from 'react';
import {domain, adminSubDomain, partypoker_login_rurl} from '../../common/config.js';
import AuthenticateUser from '../AuthenticateUser.js'
import { Redirect } from 'react-router';
import { saveActivity, saveUserTracking } from '../../common/commonService'
import $ from 'jquery'
const queryString = require('query-string');
import axios from "axios";

class Login extends React.Component {
    constructor(props) {
        super(props)
        // console.log(props);
        
        this.state = {
            showErr: false,
            errorMsg: '',
            location: '/',
            pageRedirect: '',
            loginRedirect: false,
            params: queryString.parse(props.location.search)
        }
        
    }   

    componentWillMount() {
        this.setState({params: {...this.state.params, sId: this.state.params.sId ? this.state.params.sId : this.state.params.sid}})
    }

    redirectToLogin = (path) => {
        const [subdomain] = path.split('.');
        if(subdomain == adminSubDomain) {
            this.setState({location : '/mygamelogin', loginRedirect : true})
        } else {
           window.open(partypoker_login_rurl, "_self", "toolbar=yes,scrollbars=yes,resizable=yes");            
        }
    }

    async componentDidMount() {
        let gameType = "cash", gameSubType = "NLH", ringType = "6-seater", dateRange = "Today", totalHandPlayed = 0
        let access = JSON.parse(localStorage.getItem('userRole'))
       // 
        if(localStorage.getItem('token')){    
            AuthenticateUser.validateUser()
                .then(async (data) => {
                    // console.log('componentDidMount',data);
                    this.setState({loginRedirect: true})            
                    if(localStorage.getItem('loggedInType') === 'MyGame')
                         this.setState({location: '/pokerwatch'})
                        //  else if(localStorage.getItem('loggedInType') === 'PartyPoker') this.setState({location: '/SkillLevel?logintype=player'})
                    else if(localStorage.getItem('loggedInType') === 'PartyPoker') this.setState({location: `/home?${queryString.stringify({ gameType, gameSubType, ringType, dateRange, totalHandPlayed })}`
    })
                    else this.redirectToLogin(window.location.hostname);
                })
                .catch(async (err) => {
                    this.setState({loginRedirect: true})            
                    const loginPath = localStorage.getItem('loggedInType')
                    localStorage.clear()
                    if(loginPath === 'MyGame') this.setState({location: '/mygamelogin'})
                    else if(loginPath === 'partyPoker' || loginPath === 'PartyPoker') window.open(partypoker_login_rurl, "_self", "toolbar=yes,scrollbars=yes,resizable=yes");
                    else this.redirectToLogin(window.location.hostname);
                })                    
        } else {
            if(!this.state.params.sId) 
                this.redirectToLogin(window.location.hostname);                 
        }
    }

    getIp() {
        return axios.get('https://api.ipify.org?format=json')
        .then(function (response) {
            return response.data.ip
        })
        .catch(function (error) {
            return null
        });
    }

    generateId() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 15; i++)
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

    saveTrackn(actvTrack) {
        if(localStorage.getItem("trackerId") == null || localStorage.getItem("trackerId") == '') {
            let anonyId = this.generateId()
            localStorage.setItem("trackerId", anonyId)
            actvTrack.userid = anonyId
        } else {
            actvTrack.userid = localStorage.getItem("trackerId")
        }     
        actvTrack.session_id  = "anonymous"
        saveActivity(actvTrack)
        // saveUserTracking({trackerId: anonyId, userId: null, ipAddress: actvTrack.deviceInfo.ip})
    }

    render() {
        
        return (
            <div>
                {this.state.loginRedirect && (<Redirect to={this.state.location} />)}
                <div className="app-content-loading" style={{backgroundColor: '#2D2C34'}}>
                    <center>
                    <img id="loadingImg" src={require('../../img/login-logo.png')} style={{width:'30%',marginTop:'10%'}} alt="Loading..." />
                    </center>
                </div>
            </div>
        )
    }
}

export default Login


/** WEBPACK FOOTER **
 ** ./src/components/Login/Login.js
 **/